import {Dialog, Notify, Toast} from "vant";

export default {
    /**
     * 文字提示
     * @param message
     */
    alert(message) {
        Toast(message);
    }, /**
     * 成功提示
     * @param message
     */
    success(message) {
        Toast.success(message);
    }, /**
     * 失败提示
     * @param message
     */
    fail(message) {
        Toast.fail(message);
    }, /**
     *  打开遮罩层
     * @param message
     */
    loading(message = '加载中,请稍等') {
        Toast.loading({
            message: message, forbidClick: true, overlay: 'true',
            duration: 0
        });
    }, /**
     * 关闭遮罩层
     * @param message
     */
    closeLoading() {
        Toast.clear()
    }, /**
     * 通知
     * @param message
     */
    notify(message) {
        Notify(message);
    },
    /**
     * 询问框
     * @param content
     * @param confirmButtonText
     * @param cancelButtonText
     * @returns {Promise<DialogAction>}
     */
    confirm(content, confirmButtonText = '确定', cancelButtonText = '取消') {
        return Dialog.confirm({
            title: '提示', message: content, confirmButtonText: confirmButtonText, cancelButtonText: cancelButtonText
        })
    }
}


